export default function Index(imageUrl) {
  if (!imageUrl) return '';

  const logoContent = `
      <img
        src='${imageUrl}'
        alt="Logo da empresa"
        height="52"
        width="120"
        style="height: 52px; width: auto; max-height: 52px; max-width: 140px; object-fit: contain; display: block;"
      />`;
  return logoContent;
}
